import { BRAND } from "../../brand";

export default function FirmwareDone({ updateEntry, onDone }) {
  const nodeName = updateEntry?.nodeName ?? "Device";
  const newVersion = updateEntry?.availableVersion ?? "";
  return (
    <div className="space-y-5 pt-4">
      <div className="flex flex-col items-center justify-center gap-3 text-center pt-8">
        <div
          className="flex h-24 w-24 items-center justify-center rounded-full shadow-inner"
          style={{ backgroundColor: BRAND.magenta }}
        >
          <span className="text-4xl font-semibold text-white">✓</span>
        </div>
        <div className="space-y-1">
          <p className="text-lg font-semibold text-brand-light">Update Successful</p>
          <p className="text-sm text-brand-light/70 max-w-[280px] mx-auto">
            {nodeName} has been successfully updated to {newVersion}.
            The device will now restart.
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onDone}
        className="w-full rounded-2xl bg-brand-magenta px-4 py-3 text-sm font-semibold text-white shadow hover:bg-brand-pink transition active:scale-[0.99]"
      >
        Done
      </button>
    </div>
  );
}
